<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { useId } from 'reka-ui';
import { computed } from 'vue';
import { SphSelect } from '@/components/base/select';
import { useI18n } from '@/composables/i18n';
import { cn } from '@/utils/shadcn/lib/utils';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = defineProps<{
    pageSizes: number[]
    disabled?: boolean
    class?: HTMLAttributes['class']
}>();

const itemsPerPage = defineModel<number>({ required: true });

const { i18n } = useI18n();

// SphSelect drops fallthrough attrs, so the trigger is labelled through its id instead.
const triggerId = useId();

const options = computed(() => props.pageSizes.map((size) => ({ value: size, label: String(size) })));

// SphSelect reports a cleared selection as '', which would divide the page count by zero.
function onSelect(value: unknown): void {
    const size = Number(value);

    if (Number.isFinite(size) && size > 0) {
        itemsPerPage.value = size;
    }
}
</script>

<template>
    <div :class="cn('flex items-center', props.class)">
        <label
            :for="triggerId"
            class="sr-only"
        >{{ i18n.t('Einträge pro Seite') }}</label>
        <SphSelect
            :id="triggerId"
            :model-value="itemsPerPage"
            :options="options"
            :null-option="false"
            :disabled="props.disabled"
            size="sm"
            class="w-16 **:data-[slot=select-value]:justify-center"
            @update:model-value="onSelect"
        />
    </div>
</template>
